export default "__VITE_ASSET__DduSipCU__"